<div #divSpinnerModal class="cargandoModal" [style.display]=" cargando ? '' : 'none'"><mat-spinner style="margin:0 auto; margin-top: 15%;" ></mat-spinner></div>

<div class="projects mb-4">
    <div class="card">
        <div class="card-header header-background">
            <div class="row">
                <div class="col-sm-6">
                    <h2>Biblioteca</h2>
                </div>
            </div>
        </div>

        <div>
            <div id="myTabContent" class="tab-content" style="padding: 20px 50px;">
                <div style="padding: 20px 50px;">
                    <div class="row">
                        <div class="d-flex justify-content-end">
                            <button (click)="cargarArchivo()" class="btn " style="background-color: #597CEE; height: 38px;color: #FFFFFF; margin-top: -30px; "><i class="fas fa-upload"></i> Cargar Archivo</button>
                        </div>
                    </div>

                    <div>
                        <table class="tables-info">
                            <thead>
                            <tr>
                                <th>Nombre Archivo</th>
                                <th>Fecha Carga</th>
                                <th></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr *ngFor="let archivo of archivosGenerales;" style="height: 48px;">
                                <td>{{ archivo.fileName }}</td>
                                <td>{{ archivo.fechaCreacion | date:'dd/MM/yyyy'}}</td>
                                <td>
                                    <button class="btn btn-danger rounded-circle" (click)="eliminarArchivo(archivo.id)" title="Eliminar Archivo"><i class="fa fa-times"></i></button>
                                    &nbsp;
                                    <button class="btn btn-info rounded-circle text-white" (click)="verDocumento(archivo)" title="Ver Archivo"><i class="fa fa-eye"></i></button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #modalCargarArchivo let-modal>
    <div class="modal-header" style="padding: 0px 50px;" width="100%">
        <h5 id="modalTitleUser" class="titulo-card-amarillo" style="    margin: 25px">Cargar Archivo</h5>
        <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body" style="padding: 0px 50px;" width="100%">
        <div class="row">
            <div class="row row-form mt-3">
                <div class="col-sm-6 ">
                    <label>Nombre</label>
                </div>
                <div class="col-sm-6">
                    <input class="form-control" type="text" id="nombreArchivo" placeholder="Nombre Archivo"  value="{{nombreArchivo}}" [(ngModel)]="nombreArchivo" >
                </div>
               
            </div>
            <div class="row row-form mt-3 mb-3">
                
                <div class="col-sm-6">
                    <label>Archivo</label>
                </div>
                <div class="col-sm-6">
                    <input class="form-control" type="file" #inputFile (change)="cambioArchivo($event)">
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-send mb-4" style="background-color: #597CEE; height: 38px;color: #FFFFFF;" (click)="subirArchivo($event)"> Guardar</button>
    </div>
</ng-template>

<ng-template #modalInforme let-modal class="modal-dialog modal-xl">
    <div class="modal-header" style="padding: 0px " width="100%">
        <h5 id="modalTitleUser" class="titulo-card-amarillo" style="    margin: 25px">Documento</h5>
        <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding: 0px;" width="100%">
        <iframe [src]="urlSafe" frameborder="0" width="100%" style="min-height: 700px;" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen> </iframe>
    </div>
</ng-template>

<ngx-spinner></ngx-spinner>